import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminSettingsComponent } from './admin-settings.component';
import { MatTabsModule } from '@angular/material/tabs';
import { GeneralSettingsComponent } from './components/general-settings/general-settings.component';
import { SmsSettingsComponent } from './components/sms-settings/sms-settings.component';
import { AiSettingsComponent } from './components/ai-settings/ai-settings.component';
import { KnowledgeDocumentModalComponent } from './components/knowledge-document-modal/knowledge-document-modal.component';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { ReactiveFormsModule } from '@angular/forms';
import { SettingsData } from '../shared/sl-data/settings';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { SlComponentsModule } from '../shared/sl-components/sl-components.module';
import { SlServicesModule } from '../shared/sl-services/sl-services.module';
import { CreateQuestionModalComponent } from './components/create-worker-role-modal/create-question-modal.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';

@NgModule({
  declarations: [
    AdminSettingsComponent,
    GeneralSettingsComponent,
    SmsSettingsComponent,
    AiSettingsComponent,
    KnowledgeDocumentModalComponent,
    CreateQuestionModalComponent
  ],
  imports: [
    CommonModule,
    MatTabsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatTooltipModule,
    MatIconModule,
    MatDialogModule,
    SlComponentsModule,
    SlServicesModule,
    DragDropModule,
    MatProgressSpinnerModule
  ],
  providers: [SettingsData],
  exports: [
    AdminSettingsComponent
  ]
})
export class AdminSettingsModule { } 